import Vue from 'vue'
import AppPreview from './AppPreview'
import AppPreviewHeader from './AppPreviewHeader'
import AppPreviewContent from './AppPreviewContent'
import AppPreviewFooter from './AppPreviewFooter'

Vue.component(AppPreview.name, AppPreview)
Vue.component(AppPreviewHeader.name, AppPreviewHeader)
Vue.component(AppPreviewContent.name, AppPreviewContent)
Vue.component(AppPreviewFooter.name, AppPreviewFooter)
